import { useEffect } from "react";

function App() {
  useEffect(() => {
    window.location.replace("/herramientas.html");
  }, []);

  return (
    <div
      data-testid="root-redirect"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Inter, system-ui, sans-serif",
        background: "#0a0a0a",
        color: "#fff",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <div
        style={{
          width: "32px",
          height: "32px",
          border: "2px solid #2563eb",
          borderTopColor: "transparent",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
        }}
      />
      <p style={{ fontSize: "14px", opacity: 0.7 }}>
        Cargando herramientas…{" "}
        <a
          href="/herramientas.html"
          style={{ color: "#60a5fa", textDecoration: "underline" }}
        >
          Ir ahora
        </a>
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default App;
